<template>
    <div class="msg">
        <div class="avatar" v-if="avatar"><img :src="avatar" /></div>
        <div class="clear" style="height: 50px" ></div>
        <div class="item" v-for="( param, key ) in params" :class="[param.type, param.style]" :key="key">
            <Phone class="value" v-if="param.type == 'phone'" :phone="param.value"></Phone>
            <Email class="value" v-else-if="param.type == 'email'" :email="param.value"></Email>
            <div class="value" v-else>{{ formatParam( param ) }}</div>
        </div>
    </div>
</template>

<script>
    import Phone from '@/components/ui/labels/Phone'
    import Email from '@/components/ui/labels/Email'

    export default {
        props: { params: Array, actions: Array, avatar: String },
        components: { Phone, Email },
        data() {
            return {
            }
        },
        methods: {
            formatParam( param ){
                switch( param.type ){
                    case 'string': return param.value;
                    case 'role': return param.value.name;
                    case 'email': return param.value;
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 22px;
        }

        &.role {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            
            &.r5 {
                background-color: $bg-role-5;
                color: $co-role-5;
            }

            & .value {
                font-size: 18px;
                text-transform: uppercase;
            }
        }
        
        &.club {
            position: relative;
        }
    }
</style>